module.exports = __webpack_public_path__ + "img/chevron-down.661c53dd.svg";